import React from 'react';
import { t } from '../i18n';

export default function StepsSection({ lang }) {
  const c = t(lang);

  return (
    <section className="relative py-20 md:py-28 overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://images.unsplash.com/photo-1556742049-0cfed4f6a45d?auto=format&fit=crop&w=2000&q=80"
          alt=""
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-[#062828]/92" />
      </div>

      <div className="relative max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="max-w-2xl mb-14">
          <h2 className="font-display text-3xl md:text-4xl font-bold text-white tracking-tight mb-3">
            {c.steps.title}
          </h2>
          <p className="text-lg text-teal-100/70 leading-relaxed">{c.steps.lead}</p>
        </div>

        <ol className="grid grid-cols-1 md:grid-cols-3 gap-10 mb-12">
          {c.steps.items.map((item, i) => (
            <li key={item.title} className="relative">
              <span className="font-display text-5xl font-bold text-teal-400/40 block mb-3">
                {String(i + 1).padStart(2, '0')}
              </span>
              <h3 className="font-display text-xl font-bold text-white mb-2">{item.title}</h3>
              <p className="text-teal-100/65 leading-relaxed">{item.text}</p>
            </li>
          ))}
        </ol>

        <a
          href="/s"
          className="inline-flex items-center gap-2 px-7 py-3.5 bg-teal-300 hover:bg-white text-teal-950 font-bold rounded-md transition-colors"
        >
          {c.steps.cta}
        </a>
      </div>
    </section>
  );
}
